<template>
  <div>

    <b-modal id="edit-modal" title="Edit Course Equivalent Request" v-model="openEditModal"
      @ok.prevent="attemptEditSubmit = true">
      <course-equivalent-form v-model="attemptEditSubmit" :terms="terms" :statuses="statuses"
        v-on:complete="save"></course-equivalent-form>
    </b-modal>

    <h3>Course Equivalents
      <b-button v-if="isCourseEquivalentsManager" v-b-modal.edit-modal variant="primary" class="ml-2 pull-right">Add
        Course Equivalent</b-button>
    </h3>

    <b-alert show>
      <p>Review Course Equivalent submissions.</p>
    </b-alert>

    <b-form inline @submit.prevent="" class="mb-2">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input v-model="filter" placeholder="Type to Search" debounce="500"></b-form-input>
        <b-input-group-append>
          <b-button @click="filter = null">Clear</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>

    <b-table striped hover :items="items" :fields="fields" :per-page="perPage" :current-page="currentPage" sort-by="name"
      :filter="filter" :filter-function="filterItems" @filtered="onFiltered" responsive show-empty>
      <template v-slot:cell(createdDate)="data">
        {{ data.item.createdDate | formatDateTime }}
      </template>
      <template v-slot:cell(details)="data">
        <router-link :to="{ name: 'courseEquivalentDetails', params: { id: data.item.id } }">Details</router-link>
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
  </div>
</template>

<script>
import courseEquivalentsApi from "../../api/courseEquivalents.js";
import termsApi from "../../api/terms.js";
import roleChecks from "../../misc/role-checks";
import CourseEquivalentForm from "../../components/workloads/course-equivalent-form";
import ToastrSettings from "../../settings/toastr-settings";
import toastr from "toastr";

export default {
  mixins: [roleChecks],

  data() {
    return {
      filter: null,
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      fields: [
        { key: "status", sortable: true, label: "Status" },
        { key: "term", sortable: true, label: "Term" },
        { key: "numberOfCourses", sortable: true, label: "Number Of Courses" },
        { key: "reason", sortable: true, label: "Reason" },
        { key: "fullName", sortable: true, label: "Faculty" },
        { key: "createdDate", sortable: true, label: "Date" },
        { key: "details", label: "" }
      ],
      openEditModal: false,
      attemptEditSubmit: false,
      items: [],
      statuses: [],
      terms: []
    };
  },

  components: {
    CourseEquivalentForm
  },

  methods: {
    filterItems(dataObject) {
      var matchedFilter = this.matchFilter(dataObject, this.filter);

      if (matchedFilter) {
        return true;
      }
      return false;
    },

    matchFilter(item, filter) {
      if (filter != "" && filter != null) {
        var found = this.search([item], this.filter);
        return found.length > 0;
      }
      return true;
    },

    search(collection, text) {
      var that = this;
      return _.filter(collection, function (object) {
        var search = that.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },

    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function (val) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function (memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    load() {
      courseEquivalentsApi
        .get()
        .then(response => {
          this.items = response.data;
          this.totalRows = this.items.length;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    save(courseEquivalent) {
      if (courseEquivalent) {
        this.attemptEditSubmit = false;
        courseEquivalentsApi.post(courseEquivalent).then(() => {
          toastr.options = ToastrSettings;
          toastr.success("The request has been saved.", "Success");
          this.load();
          this.openEditModal = false;
        });
      }
    }
  },

  created() {
    this.load();
    courseEquivalentsApi.getStatuses().then(response => {
      this.statuses = response.data;
    });

    termsApi.getCurrentAndFutureTerms().then(response => {
      this.terms = response.data;
    });
  }
};
</script>

<style></style>
